import { h, Component } from 'preact'

import { connect } from 'app/store'
import BookmarkList from 'app/components/BookmarkList'
import NewBookmark from 'app/components/NewBookmark'
import Input from 'app/components/Input'
import Form from 'app/components/Form'
import { api } from 'app/util/api'
import linkState from 'linkstate'

const listContainer = {
  minHeight: '400px',
  lineHeight: '400px',
}

const searchInput = {
  // minWidth: '280px',
}

class Dashboard extends Component {
  state = {
    bookmarks: [],
    loading: false,
    // Pagination
    currentPage: 1,
    itemsPerPage: 7,
    // Search
    q: '',
  }

  componentDidMount() {
    this.findBookmarks(true)
  }

  // User clicked on brand and we should refetch data
  componentWillReceiveProps() {
    this.findBookmarks(true)

    this.setState({ currentPage: 1 })
  }

  findBookmarks = async (showLoading = false) => {
    let bookmarks = []

    if (showLoading) {
      this.setState({ loading: true })
    }

    try {
      bookmarks = await api.get('/bookmark' + this.props.url)

      this.setState({ bookmarks })
    } finally {
      this.setState({ loading: false })
    }
  }

  removeBookmark = async id => {
    await api.del('/bookmark/' + id)

    this.findBookmarks()
  }

  scrollToTop = () => window.scrollTo(0, 0)

  renderPaginator = () => {
    const { currentPage, itemsPerPage, bookmarks } = this.state

    // To few bookmarks
    if (bookmarks.length < itemsPerPage) {
      return <div class="py-4" />
    }

    // If there's nothing else to show
    if (currentPage * itemsPerPage >= bookmarks.length) {
      return (
        <div class="text-center py-4">
          <div class="w-100 text-muted">all {bookmarks.length} loaded</div>
        </div>
      )
    }

    const showMore = () => this.setState({ currentPage: currentPage + 1 })

    return (
      <div class="text-center py-4">
        <button class="w-100 text-muted btn-link" onClick={showMore}>
          show more ({bookmarks.length - itemsPerPage})
        </button>
      </div>
    )
  }

  renderList = () => {
    const { bookmarks, loading, currentPage, itemsPerPage } = this.state

    if (loading) {
      return (
        <div style={listContainer} class="text-center my-5">
          Loading...
        </div>
      )
    } else if (!loading && bookmarks.length === 0) {
      return (
        <div style={listContainer} class="text-center my-5">
          No bookmarks found.
        </div>
      )
    } else if (!loading && bookmarks.length > 0) {
      return (
        <div style={{ minHeight: 200 }}>
          <BookmarkList
            bookmarks={bookmarks.slice(0, itemsPerPage * currentPage)}
            removeBookmark={this.removeBookmark}
          />
          {this.renderPaginator()}
        </div>
      )
    }
  }

  renderSearch = () => {
    const searchBookmarks = async () => {
      // @TODO: Cache bookmarks instead of re-fetching
      await this.findBookmarks()

      const { q } = this.state

      if (!q) return

      const results = this.state.bookmarks.filter(b => {
        const tags = b.tags.map(tag => tag.name).join(' ')

        return b.url.includes(q) || b.title.includes(q) || tags.includes(q)
      })

      this.scrollToTop()

      this.setState({ bookmarks: results })
    }

    return (
      <div class="text-center">
        <Form autocomplete="off" onSubmit={() => searchBookmarks()}>
          <input style="opacity: 0;position: absolute;" />
          <Input
            autocomplete="off"
            placeholder="Search..."
            value={this.state.q}
            onInput={linkState(this, 'q')}
          />
        </Form>
      </div>
    )
  }

  render() {
    const { bookmarks, loading } = this.state

    const finishedLoading = !loading && bookmarks.length > 0

    return (
      <div>
        <NewBookmark onCreate={this.findBookmarks} />
        {this.renderList()}
        {finishedLoading && (
          <div className="row mb-5">
            <div className="py-2 col-12">{this.renderSearch()}</div>
          </div>
        )}
      </div>
    )
  }
}

export default connect(
  'bookmark',
  Dashboard,
)



// WEBPACK FOOTER //
// ./pages/Dashboard.js